export default {
    auth: [
        {
            icon: 'mdi-home-outline',
            name: 'Home',
            to: {name: 'home'}
        },
        {
            icon: 'mdi-account-circle-outline',
            name: 'My Profile',
            to: {name: 'profile'}
        },
        {
            icon: 'mdi-book-multiple-outline',
            name: 'My Courses',
            to: {name: 'my-courses'}
        },
        {
            icon: 'mdi-play-box-multiple-outline',
            name: 'Courses',
            to: {name: 'courses'}
        },
        {
            icon: 'mdi-account-tie-outline',
            name: 'Teachers',
            to: {name: 'teachers'},
            show: 'showTeachers'
        },
        {
            icon: 'mdi-clipboard-text-outline',
            name: 'Online Exam',
            to: {name: 'exams'},
            show: 'showExams',
        },
        {
            icon: 'mdi-license',
            name: 'My Homeworks',
            to: {name: 'my-homeworks'},
        },
        {
            icon: 'mdi-license',
            name: 'My Exams',
            to: {name: 'my-exams'},
        },
        {
            icon: 'mdi-wallet-outline',
            name: 'Wallet',
            to: {name: 'wallet'},
            show: 'showWallet',
        },
        {
            icon: 'mdi-information-outline',
            name: 'About Platform',
            to: {name: 'about'},
            divider: true,
        },
        {
            icon: 'mdi-text-box-outline',
            name: 'Privacy Policy',
            to: '/privacy-policy'
        },
        {
            icon: 'mdi-help',
            name: 'Contact Us',
            to: {name: 'help'}
        }
    ],
    guest: [
        {
            icon: 'mdi-home-outline',
            name: 'Home',
            to: {name: 'welcome'}
        },
        {
            icon: 'mdi-account-plus-outline',
            name: 'Register',
            to: {name: 'register'}
        },
        {
            icon: 'mdi-login-variant',
            name: 'Login',
            to: {name: 'login'}
        },
        {
            icon: 'mdi-information-outline',
            name: 'About Platform',
            to: {name: 'about'}
        },
        {
            icon: 'mdi-help',
            name: 'Contact Us',
            to: {name: 'help'}
        }
    ]
}